/* tslint:disable */
/* eslint-disable */
/**
 * OnData.Backup
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AlertAndTime
 */
export interface AlertAndTime {
    /**
     * 
     * @type {string}
     * @memberof AlertAndTime
     */
    'alert'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AlertAndTime
     */
    'isWarning'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AlertAndTime
     */
    'alertTime'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AlertAndTime
     */
    'databaseId'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof AlertAndTime
     */
    'parameters'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface BackupDashboardResponseDto
 */
export interface BackupDashboardResponseDto {
    /**
     * 
     * @type {number}
     * @memberof BackupDashboardResponseDto
     */
    'backupSuccessCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof BackupDashboardResponseDto
     */
    'backupWarningCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof BackupDashboardResponseDto
     */
    'backupFailedCount'?: number;
    /**
     * 
     * @type {Array<AlertAndTime>}
     * @memberof BackupDashboardResponseDto
     */
    'backupAlerts'?: Array<AlertAndTime> | null;
    /**
     * 
     * @type {number}
     * @memberof BackupDashboardResponseDto
     */
    'validationSuccessCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof BackupDashboardResponseDto
     */
    'validationWarningCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof BackupDashboardResponseDto
     */
    'validationFailedCount'?: number;
    /**
     * 
     * @type {Array<AlertAndTime>}
     * @memberof BackupDashboardResponseDto
     */
    'validationAlerts'?: Array<AlertAndTime> | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum BackupJobStatus {
    NoBackup = 0,
    InProgress = 1,
    Failed = 2,
    Received = 3
}

/**
 * 
 * @export
 * @interface BackupResponseDto
 */
export interface BackupResponseDto {
    /**
     * 
     * @type {number}
     * @memberof BackupResponseDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof BackupResponseDto
     */
    'databaseId'?: number;
    /**
     * 
     * @type {number}
     * @memberof BackupResponseDto
     */
    'backupId'?: number;
    /**
     * 
     * @type {number}
     * @memberof BackupResponseDto
     */
    'engineId'?: number;
    /**
     * 
     * @type {string}
     * @memberof BackupResponseDto
     */
    'engineVersion'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BackupResponseDto
     */
    'engineEdition'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BackupResponseDto
     */
    'buildVersion'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BackupResponseDto
     */
    'scriptFolder'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BackupResponseDto
     */
    'path'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BackupResponseDto
     */
    'size'?: number;
    /**
     * 
     * @type {string}
     * @memberof BackupResponseDto
     */
    'sizeText'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BackupResponseDto
     */
    'createdTime'?: string;
    /**
     * 
     * @type {string}
     * @memberof BackupResponseDto
     */
    'receivedTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BackupResponseDto
     */
    'validationStartTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BackupResponseDto
     */
    'validationEndTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BackupResponseDto
     */
    'restoreEndTime'?: string | null;
    /**
     * 
     * @type {BackupType}
     * @memberof BackupResponseDto
     */
    'backupType'?: BackupType;
    /**
     * 
     * @type {string}
     * @memberof BackupResponseDto
     */
    'backupTypeText'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BackupResponseDto
     */
    'backupLog'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BackupResponseDto
     */
    'backupException'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BackupResponseDto
     */
    'restoreLog'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BackupResponseDto
     */
    'restoreException'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BackupResponseDto
     */
    'validationLog'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BackupResponseDto
     */
    'validationException'?: string | null;
    /**
     * 
     * @type {BackupStatus}
     * @memberof BackupResponseDto
     */
    'status'?: BackupStatus;
    /**
     * 
     * @type {string}
     * @memberof BackupResponseDto
     */
    'statusText'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof BackupResponseDto
     */
    'isFileDeleted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BackupResponseDto
     */
    'isEncrypted'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof BackupResponseDto
     */
    'snapshotId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof BackupResponseDto
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof BackupResponseDto
     */
    'latestFullBackupSize'?: number;
}
/**
 * 
 * @export
 * @interface BackupResponseDtoPaginationResult
 */
export interface BackupResponseDtoPaginationResult {
    /**
     * 
     * @type {Array<BackupResponseDto>}
     * @memberof BackupResponseDtoPaginationResult
     */
    'items'?: Array<BackupResponseDto> | null;
    /**
     * 
     * @type {number}
     * @memberof BackupResponseDtoPaginationResult
     */
    'total'?: number;
}
/**
 * 
 * @export
 * @interface BackupScheduleInput
 */
export interface BackupScheduleInput {
    /**
     * 
     * @type {number}
     * @memberof BackupScheduleInput
     */
    'databaseId'?: number;
    /**
     * 
     * @type {BackupType}
     * @memberof BackupScheduleInput
     */
    'backupType'?: BackupType;
    /**
     * 
     * @type {ValidationFrequency}
     * @memberof BackupScheduleInput
     */
    'frequency'?: ValidationFrequency;
    /**
     * 
     * @type {number}
     * @memberof BackupScheduleInput
     */
    'interval'?: number;
    /**
     * 
     * @type {number}
     * @memberof BackupScheduleInput
     */
    'startHour'?: number;
    /**
     * 
     * @type {number}
     * @memberof BackupScheduleInput
     */
    'startMinute'?: number;
    /**
     * 
     * @type {string}
     * @memberof BackupScheduleInput
     */
    'daysOfWeek'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BackupScheduleInput
     */
    'dayOfMonth'?: number;
}
/**
 * 
 * @export
 * @interface BackupScheduleResponseDto
 */
export interface BackupScheduleResponseDto {
    /**
     * 
     * @type {number}
     * @memberof BackupScheduleResponseDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof BackupScheduleResponseDto
     */
    'databaseId'?: number;
    /**
     * 
     * @type {BackupType}
     * @memberof BackupScheduleResponseDto
     */
    'backupType'?: BackupType;
    /**
     * 
     * @type {ValidationFrequency}
     * @memberof BackupScheduleResponseDto
     */
    'frequency'?: ValidationFrequency;
    /**
     * 
     * @type {number}
     * @memberof BackupScheduleResponseDto
     */
    'interval'?: number;
    /**
     * 
     * @type {number}
     * @memberof BackupScheduleResponseDto
     */
    'startHour'?: number;
    /**
     * 
     * @type {number}
     * @memberof BackupScheduleResponseDto
     */
    'startMinute'?: number;
    /**
     * 
     * @type {string}
     * @memberof BackupScheduleResponseDto
     */
    'daysOfWeek'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BackupScheduleResponseDto
     */
    'dayOfMonth'?: number;
    /**
     * 
     * @type {string}
     * @memberof BackupScheduleResponseDto
     */
    'cronExpression'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BackupScheduleResponseDto
     */
    'timeZoneName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BackupScheduleResponseDto
     */
    'timeZoneOffset'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum BackupStatus {
    BackingUp = 0,
    BackupSuccess = 1,
    BackupFailed = 2,
    Validating = 3,
    RestoreFailed = 4,
    ValidationFailed = 5,
    ValidationSuccess = 6
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum BackupType {
    Differential = 0,
    Full = 1,
    Log = 2,
    Incremental = 3
}

/**
 * 
 * @export
 * @interface BackupTypeResponseDto
 */
export interface BackupTypeResponseDto {
    /**
     * 
     * @type {BackupType}
     * @memberof BackupTypeResponseDto
     */
    'backupType'?: BackupType;
    /**
     * 
     * @type {string}
     * @memberof BackupTypeResponseDto
     */
    'text'?: string | null;
}
/**
 * 
 * @export
 * @interface ClientCreateDatabaseInput
 */
export interface ClientCreateDatabaseInput {
    /**
     * 
     * @type {string}
     * @memberof ClientCreateDatabaseInput
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ClientCreateDatabaseInput
     */
    'physicalDatabaseName'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ClientCreateDatabaseInput
     */
    'schemas'?: Array<string> | null;
    /**
     * 
     * @type {DatabaseType}
     * @memberof ClientCreateDatabaseInput
     */
    'databaseType': DatabaseType;
    /**
     * 
     * @type {string}
     * @memberof ClientCreateDatabaseInput
     */
    'engineVersion': string;
    /**
     * 
     * @type {string}
     * @memberof ClientCreateDatabaseInput
     */
    'edition'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientCreateDatabaseInput
     */
    'description'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ClientCreateDatabaseInput
     */
    'encryptionKeyId': number;
    /**
     * 
     * @type {string}
     * @memberof ClientCreateDatabaseInput
     */
    'clientId'?: string | null;
}
/**
 * 
 * @export
 * @interface ClientReportDatabaseSizeInput
 */
export interface ClientReportDatabaseSizeInput {
    /**
     * 
     * @type {string}
     * @memberof ClientReportDatabaseSizeInput
     */
    'databaseName': string;
    /**
     * 
     * @type {number}
     * @memberof ClientReportDatabaseSizeInput
     */
    'databaseSize'?: number;
}
/**
 * 
 * @export
 * @interface ClientUpdateDatabaseInput
 */
export interface ClientUpdateDatabaseInput {
    /**
     * 
     * @type {number}
     * @memberof ClientUpdateDatabaseInput
     */
    'databaseId': number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ClientUpdateDatabaseInput
     */
    'schemas'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface CloneDatabaseInput
 */
export interface CloneDatabaseInput {
    /**
     * 
     * @type {string}
     * @memberof CloneDatabaseInput
     */
    'databaseName': string;
    /**
     * 
     * @type {number}
     * @memberof CloneDatabaseInput
     */
    'engineId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CloneDatabaseInput
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum CloudProvider {
    Azure = 1,
    AzureUSGovernment = 2,
    Aws = 3,
    Gcp = 4
}

/**
 * 
 * @export
 * @interface CollectionInfoInput
 */
export interface CollectionInfoInput {
    /**
     * 
     * @type {string}
     * @memberof CollectionInfoInput
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CollectionInfoInput
     */
    'partitionKey'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CollectionInfoInput
     */
    'totalRows'?: number;
    /**
     * 
     * @type {string}
     * @memberof CollectionInfoInput
     */
    'jsonSchema'?: string | null;
}
/**
 * 
 * @export
 * @interface CreateBackupInput
 */
export interface CreateBackupInput {
    /**
     * 
     * @type {number}
     * @memberof CreateBackupInput
     */
    'databaseId'?: number;
    /**
     * 
     * @type {BackupType}
     * @memberof CreateBackupInput
     */
    'backupType': BackupType;
    /**
     * 
     * @type {DatabaseType}
     * @memberof CreateBackupInput
     */
    'databaseType': DatabaseType;
    /**
     * 
     * @type {string}
     * @memberof CreateBackupInput
     */
    'engineVersion': string;
    /**
     * 
     * @type {string}
     * @memberof CreateBackupInput
     */
    'edition'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateBackupInput
     */
    'buildVersion'?: string | null;
}
/**
 * 
 * @export
 * @interface CreateDatabaseInput
 */
export interface CreateDatabaseInput {
    /**
     * 
     * @type {string}
     * @memberof CreateDatabaseInput
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof CreateDatabaseInput
     */
    'engineId': number;
    /**
     * 
     * @type {string}
     * @memberof CreateDatabaseInput
     */
    'description'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CreateDatabaseInput
     */
    'encryptionKeyId': number;
}
/**
 * 
 * @export
 * @interface DatabaseResponseDto
 */
export interface DatabaseResponseDto {
    /**
     * 
     * @type {number}
     * @memberof DatabaseResponseDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DatabaseResponseDto
     */
    'databaseId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DatabaseResponseDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DatabaseResponseDto
     */
    'physicalDatabaseName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DatabaseResponseDto
     */
    'schemas'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DatabaseResponseDto
     */
    'description'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DatabaseResponseDto
     */
    'engineId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DatabaseResponseDto
     */
    'engineVersion'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DatabaseResponseDto
     */
    'engineEdition'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DatabaseResponseDto
     */
    'retentionDaysId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DatabaseResponseDto
     */
    'retentionDays'?: number;
    /**
     * 
     * @type {DatabaseType}
     * @memberof DatabaseResponseDto
     */
    'databaseType'?: DatabaseType;
    /**
     * 
     * @type {string}
     * @memberof DatabaseResponseDto
     */
    'createdTime'?: string;
    /**
     * 
     * @type {number}
     * @memberof DatabaseResponseDto
     */
    'size'?: number;
    /**
     * 
     * @type {string}
     * @memberof DatabaseResponseDto
     */
    'sizeText'?: string | null;
    /**
     * 
     * @type {ResultLevel}
     * @memberof DatabaseResponseDto
     */
    'backupResult'?: ResultLevel;
    /**
     * 
     * @type {number}
     * @memberof DatabaseResponseDto
     */
    'backupResultRefId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DatabaseResponseDto
     */
    'backupAlert'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DatabaseResponseDto
     */
    'lastBackupTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DatabaseResponseDto
     */
    'backupFailedLog'?: string | null;
    /**
     * 
     * @type {ResultLevel}
     * @memberof DatabaseResponseDto
     */
    'validationResult'?: ResultLevel;
    /**
     * 
     * @type {number}
     * @memberof DatabaseResponseDto
     */
    'validationResultRefId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DatabaseResponseDto
     */
    'validationAlert'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DatabaseResponseDto
     */
    'lastValidationTime'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DatabaseResponseDto
     */
    'validationFailedLog'?: string | null;
    /**
     * 
     * @type {BackupJobStatus}
     * @memberof DatabaseResponseDto
     */
    'backupJobStatus'?: BackupJobStatus;
    /**
     * 
     * @type {string}
     * @memberof DatabaseResponseDto
     */
    'backupJobStatusText'?: string | null;
    /**
     * 
     * @type {ValidationJobStatus}
     * @memberof DatabaseResponseDto
     */
    'validationJobStatus'?: ValidationJobStatus;
    /**
     * 
     * @type {string}
     * @memberof DatabaseResponseDto
     */
    'validationJobStatusText'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DatabaseResponseDto
     */
    'rto'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DatabaseResponseDto
     */
    'rpo'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DatabaseResponseDto
     */
    'lastBackupSuccessTime'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseResponseDto
     */
    'isManaged'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseResponseDto
     */
    'isNotificationEnabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseResponseDto
     */
    'isDeleted'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseResponseDto
     */
    'hasSchema'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DatabaseResponseDto
     */
    'autoClassified'?: boolean;
}
/**
 * 
 * @export
 * @interface DatabaseSchemaInput
 */
export interface DatabaseSchemaInput {
    /**
     * 
     * @type {number}
     * @memberof DatabaseSchemaInput
     */
    'databaseId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DatabaseSchemaInput
     */
    'backupId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DatabaseSchemaInput
     */
    'validationCode': string;
    /**
     * 
     * @type {Array<TableInfoInput>}
     * @memberof DatabaseSchemaInput
     */
    'tables'?: Array<TableInfoInput> | null;
    /**
     * 
     * @type {Array<FieldInfoInput>}
     * @memberof DatabaseSchemaInput
     */
    'fields'?: Array<FieldInfoInput> | null;
    /**
     * 
     * @type {Array<PrimaryKeyInfoInput>}
     * @memberof DatabaseSchemaInput
     */
    'primaryKeys'?: Array<PrimaryKeyInfoInput> | null;
    /**
     * 
     * @type {Array<ForeignKeyInfoInput>}
     * @memberof DatabaseSchemaInput
     */
    'foreignKeys'?: Array<ForeignKeyInfoInput> | null;
    /**
     * 
     * @type {Array<TriggerInfoInput>}
     * @memberof DatabaseSchemaInput
     */
    'triggers'?: Array<TriggerInfoInput> | null;
    /**
     * 
     * @type {Array<IndexInfoInput>}
     * @memberof DatabaseSchemaInput
     */
    'indexes'?: Array<IndexInfoInput> | null;
    /**
     * 
     * @type {Array<ProcedureInfoInput>}
     * @memberof DatabaseSchemaInput
     */
    'procedures'?: Array<ProcedureInfoInput> | null;
    /**
     * 
     * @type {Array<ViewInfoInput>}
     * @memberof DatabaseSchemaInput
     */
    'views'?: Array<ViewInfoInput> | null;
    /**
     * 
     * @type {Array<ViewFieldInfoInput>}
     * @memberof DatabaseSchemaInput
     */
    'viewFields'?: Array<ViewFieldInfoInput> | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum DatabaseType {
    MySQL = 1,
    PostgreSQL = 2,
    SQLServer = 3,
    MongoDB = 4,
    MariaDB = 5,
    Oracle = 6,
    DB2 = 7,
    Hana = 8,
    Snowflake = 9,
    CosmosDB = 10
}

/**
 * 
 * @export
 * @interface DecryptThenEncryptInput
 */
export interface DecryptThenEncryptInput {
    /**
     * 
     * @type {number}
     * @memberof DecryptThenEncryptInput
     */
    'organizationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DecryptThenEncryptInput
     */
    'publicXml'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DecryptThenEncryptInput
     */
    'encryptedBytes'?: string | null;
}
/**
 * 
 * @export
 * @interface DownloadAuthenticateInput
 */
export interface DownloadAuthenticateInput {
    /**
     * 
     * @type {number}
     * @memberof DownloadAuthenticateInput
     */
    'databaseId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DownloadAuthenticateInput
     */
    'backupId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DownloadAuthenticateInput
     */
    'downloadId'?: number;
    /**
     * 
     * @type {string}
     * @memberof DownloadAuthenticateInput
     */
    'publicKey'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DownloadAuthenticateInput
     */
    'message'?: string | null;
}
/**
 * 
 * @export
 * @interface EngineResponseDto
 */
export interface EngineResponseDto {
    /**
     * 
     * @type {number}
     * @memberof EngineResponseDto
     */
    'id'?: number;
    /**
     * 
     * @type {DatabaseType}
     * @memberof EngineResponseDto
     */
    'databaseType'?: DatabaseType;
    /**
     * 
     * @type {string}
     * @memberof EngineResponseDto
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EngineResponseDto
     */
    'version'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EngineResponseDto
     */
    'edition'?: string | null;
    /**
     * 
     * @type {EngineStatus}
     * @memberof EngineResponseDto
     */
    'status'?: EngineStatus;
    /**
     * 
     * @type {boolean}
     * @memberof EngineResponseDto
     */
    'isDeleted'?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum EngineStatus {
    Production = 0,
    Beta = 1,
    EOL = 2
}

/**
 * 
 * @export
 * @interface EnumOptionResponseDto
 */
export interface EnumOptionResponseDto {
    /**
     * 
     * @type {number}
     * @memberof EnumOptionResponseDto
     */
    'key'?: number;
    /**
     * 
     * @type {string}
     * @memberof EnumOptionResponseDto
     */
    'text'?: string | null;
    /**
     * 
     * @type {DatabaseType}
     * @memberof EnumOptionResponseDto
     */
    'databaseType'?: DatabaseType;
}
/**
 * 
 * @export
 * @interface FieldInfoInput
 */
export interface FieldInfoInput {
    /**
     * 
     * @type {string}
     * @memberof FieldInfoInput
     */
    'tableSchema'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FieldInfoInput
     */
    'tableName': string;
    /**
     * 
     * @type {string}
     * @memberof FieldInfoInput
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof FieldInfoInput
     */
    'type'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FieldInfoInput
     */
    'position': number;
    /**
     * 
     * @type {number}
     * @memberof FieldInfoInput
     */
    'maxLength'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FieldInfoInput
     */
    'precision'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof FieldInfoInput
     */
    'scale'?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof FieldInfoInput
     */
    'isNullable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FieldInfoInput
     */
    'isIdentity'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FieldInfoInput
     */
    'isComputed'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FieldInfoInput
     */
    'isRowVersionGA'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FieldInfoInput
     */
    'defaultValue'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FieldInfoInput
     */
    'comment'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FieldInfoInput
     */
    'dataInfoTypeId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof FieldInfoInput
     */
    'defaultSecondClassification'?: number;
    /**
     * 
     * @type {number}
     * @memberof FieldInfoInput
     */
    'defaultEncryptionRule'?: number;
}
/**
 * 
 * @export
 * @interface ForeignKeyInfoInput
 */
export interface ForeignKeyInfoInput {
    /**
     * 
     * @type {string}
     * @memberof ForeignKeyInfoInput
     */
    'tableSchema'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ForeignKeyInfoInput
     */
    'tableName': string;
    /**
     * 
     * @type {string}
     * @memberof ForeignKeyInfoInput
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof ForeignKeyInfoInput
     */
    'position'?: number;
    /**
     * 
     * @type {string}
     * @memberof ForeignKeyInfoInput
     */
    'columnName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ForeignKeyInfoInput
     */
    'referencedSchemaName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ForeignKeyInfoInput
     */
    'referencedTableName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ForeignKeyInfoInput
     */
    'referencedPositon'?: number;
    /**
     * 
     * @type {string}
     * @memberof ForeignKeyInfoInput
     */
    'referencedColumnName'?: string | null;
}
/**
 * 
 * @export
 * @interface GetBackupFilesWithUriInput
 */
export interface GetBackupFilesWithUriInput {
    /**
     * 
     * @type {number}
     * @memberof GetBackupFilesWithUriInput
     */
    'databaseId'?: number;
    /**
     * 
     * @type {number}
     * @memberof GetBackupFilesWithUriInput
     */
    'backupId'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetBackupFilesWithUriInput
     */
    'publicKeyXml': string;
    /**
     * 
     * @type {string}
     * @memberof GetBackupFilesWithUriInput
     */
    'validationCode': string;
}
/**
 * 
 * @export
 * @interface IndexInfoInput
 */
export interface IndexInfoInput {
    /**
     * 
     * @type {string}
     * @memberof IndexInfoInput
     */
    'tableSchema'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IndexInfoInput
     */
    'tableName': string;
    /**
     * 
     * @type {string}
     * @memberof IndexInfoInput
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof IndexInfoInput
     */
    'isPrimaryKey'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IndexInfoInput
     */
    'isUnique'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IndexInfoInput
     */
    'isClustered'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof IndexInfoInput
     */
    'position'?: number;
    /**
     * 
     * @type {string}
     * @memberof IndexInfoInput
     */
    'columnName'?: string | null;
}
/**
 * 
 * @export
 * @interface InternalListBackupsInput
 */
export interface InternalListBackupsInput {
    /**
     * 
     * @type {number}
     * @memberof InternalListBackupsInput
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof InternalListBackupsInput
     */
    'databaseId'?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof InternalListBackupsInput
     */
    'backupIds'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface NoSqlDatabaseSchemaInput
 */
export interface NoSqlDatabaseSchemaInput {
    /**
     * 
     * @type {number}
     * @memberof NoSqlDatabaseSchemaInput
     */
    'databaseId'?: number;
    /**
     * 
     * @type {string}
     * @memberof NoSqlDatabaseSchemaInput
     */
    'databaseName'?: string | null;
    /**
     * 
     * @type {Array<CollectionInfoInput>}
     * @memberof NoSqlDatabaseSchemaInput
     */
    'collections'?: Array<CollectionInfoInput> | null;
    /**
     * 
     * @type {Array<PropertyInfoInput>}
     * @memberof NoSqlDatabaseSchemaInput
     */
    'properties'?: Array<PropertyInfoInput> | null;
}
/**
 * 
 * @export
 * @interface PrimaryKeyInfoInput
 */
export interface PrimaryKeyInfoInput {
    /**
     * 
     * @type {string}
     * @memberof PrimaryKeyInfoInput
     */
    'tableSchema'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PrimaryKeyInfoInput
     */
    'tableName': string;
    /**
     * 
     * @type {string}
     * @memberof PrimaryKeyInfoInput
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof PrimaryKeyInfoInput
     */
    'position'?: number;
    /**
     * 
     * @type {string}
     * @memberof PrimaryKeyInfoInput
     */
    'columnName'?: string | null;
}
/**
 * 
 * @export
 * @interface ProcedureInfoInput
 */
export interface ProcedureInfoInput {
    /**
     * 
     * @type {string}
     * @memberof ProcedureInfoInput
     */
    'schema'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProcedureInfoInput
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ProcedureInfoInput
     */
    'definition'?: string | null;
}
/**
 * 
 * @export
 * @interface PropertyInfoInput
 */
export interface PropertyInfoInput {
    /**
     * 
     * @type {string}
     * @memberof PropertyInfoInput
     */
    'collectionName': string;
    /**
     * 
     * @type {string}
     * @memberof PropertyInfoInput
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PropertyInfoInput
     */
    'type'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PropertyInfoInput
     */
    'precision'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PropertyInfoInput
     */
    'scale'?: number | null;
}
/**
 * 
 * @export
 * @interface ReportResultInput
 */
export interface ReportResultInput {
    /**
     * 
     * @type {number}
     * @memberof ReportResultInput
     */
    'databaseId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ReportResultInput
     */
    'backupId'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ReportResultInput
     */
    'isSuccess'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ReportResultInput
     */
    'log'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportResultInput
     */
    'exception'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReportResultInput
     */
    'validationCode'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ReportResultInput
     */
    'isEncoded'?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum ResultLevel {
    Success = 0,
    Warning = 1,
    Failed = 2
}

/**
 * 
 * @export
 * @interface SchemaOnlyBackupInput
 */
export interface SchemaOnlyBackupInput {
    /**
     * 
     * @type {number}
     * @memberof SchemaOnlyBackupInput
     */
    'databaseId'?: number;
    /**
     * 
     * @type {string}
     * @memberof SchemaOnlyBackupInput
     */
    'databaseName'?: string | null;
    /**
     * 
     * @type {Array<TableInfoInput>}
     * @memberof SchemaOnlyBackupInput
     */
    'tables'?: Array<TableInfoInput> | null;
    /**
     * 
     * @type {Array<FieldInfoInput>}
     * @memberof SchemaOnlyBackupInput
     */
    'fields'?: Array<FieldInfoInput> | null;
    /**
     * 
     * @type {Array<PrimaryKeyInfoInput>}
     * @memberof SchemaOnlyBackupInput
     */
    'primaryKeys'?: Array<PrimaryKeyInfoInput> | null;
    /**
     * 
     * @type {Array<ForeignKeyInfoInput>}
     * @memberof SchemaOnlyBackupInput
     */
    'foreignKeys'?: Array<ForeignKeyInfoInput> | null;
    /**
     * 
     * @type {Array<TriggerInfoInput>}
     * @memberof SchemaOnlyBackupInput
     */
    'triggers'?: Array<TriggerInfoInput> | null;
    /**
     * 
     * @type {Array<IndexInfoInput>}
     * @memberof SchemaOnlyBackupInput
     */
    'indexes'?: Array<IndexInfoInput> | null;
    /**
     * 
     * @type {Array<ProcedureInfoInput>}
     * @memberof SchemaOnlyBackupInput
     */
    'procedures'?: Array<ProcedureInfoInput> | null;
    /**
     * 
     * @type {Array<ViewInfoInput>}
     * @memberof SchemaOnlyBackupInput
     */
    'views'?: Array<ViewInfoInput> | null;
    /**
     * 
     * @type {Array<ViewFieldInfoInput>}
     * @memberof SchemaOnlyBackupInput
     */
    'viewFields'?: Array<ViewFieldInfoInput> | null;
}
/**
 * 
 * @export
 * @interface TableInfoInput
 */
export interface TableInfoInput {
    /**
     * 
     * @type {string}
     * @memberof TableInfoInput
     */
    'schema'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TableInfoInput
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof TableInfoInput
     */
    'comment'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TableInfoInput
     */
    'totalRows'?: number | null;
}
/**
 * 
 * @export
 * @interface TriggerInfoInput
 */
export interface TriggerInfoInput {
    /**
     * 
     * @type {string}
     * @memberof TriggerInfoInput
     */
    'tableSchema'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TriggerInfoInput
     */
    'tableName': string;
    /**
     * 
     * @type {string}
     * @memberof TriggerInfoInput
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof TriggerInfoInput
     */
    'eventManipulation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TriggerInfoInput
     */
    'actionTimming'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TriggerInfoInput
     */
    'actionOrientation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TriggerInfoInput
     */
    'actionStatement'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateDatabaseInput
 */
export interface UpdateDatabaseInput {
    /**
     * 
     * @type {number}
     * @memberof UpdateDatabaseInput
     */
    'databaseId': number;
    /**
     * 
     * @type {string}
     * @memberof UpdateDatabaseInput
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof UpdateDatabaseInput
     */
    'engineId': number;
    /**
     * 
     * @type {string}
     * @memberof UpdateDatabaseInput
     */
    'description'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateDatabaseInput
     */
    'retentionDaysId'?: number;
}
/**
 * 
 * @export
 * @interface ValidateDownloadFileInput
 */
export interface ValidateDownloadFileInput {
    /**
     * 
     * @type {number}
     * @memberof ValidateDownloadFileInput
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ValidateDownloadFileInput
     */
    'databaseId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ValidateDownloadFileInput
     */
    'backupId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ValidateDownloadFileInput
     */
    'downloadId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ValidateDownloadFileInput
     */
    'fileId'?: number;
    /**
     * 
     * @type {string}
     * @memberof ValidateDownloadFileInput
     */
    'guid': string;
    /**
     * 
     * @type {string}
     * @memberof ValidateDownloadFileInput
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ValidateDownloadFileInput
     */
    'code': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum ValidationFrequency {
    Hourly = 1,
    Daily = 2,
    Weekly = 3,
    Monthly = 4
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum ValidationJobStatus {
    NoValidation = 0,
    InProgress = 1,
    Validated = 2,
    Failed = 3
}

/**
 * 
 * @export
 * @interface ValidationScheduleInput
 */
export interface ValidationScheduleInput {
    /**
     * 
     * @type {number}
     * @memberof ValidationScheduleInput
     */
    'databaseId'?: number;
    /**
     * 
     * @type {ValidationFrequency}
     * @memberof ValidationScheduleInput
     */
    'frequency'?: ValidationFrequency;
    /**
     * 
     * @type {number}
     * @memberof ValidationScheduleInput
     */
    'interval'?: number;
    /**
     * 
     * @type {number}
     * @memberof ValidationScheduleInput
     */
    'startHour'?: number;
    /**
     * 
     * @type {number}
     * @memberof ValidationScheduleInput
     */
    'startMinute'?: number;
    /**
     * 
     * @type {string}
     * @memberof ValidationScheduleInput
     */
    'daysOfWeek'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ValidationScheduleInput
     */
    'dayOfMonth'?: number;
}
/**
 * 
 * @export
 * @interface ValidationScheduleResponseDto
 */
export interface ValidationScheduleResponseDto {
    /**
     * 
     * @type {number}
     * @memberof ValidationScheduleResponseDto
     */
    'organizationId'?: number;
    /**
     * 
     * @type {number}
     * @memberof ValidationScheduleResponseDto
     */
    'databaseId'?: number;
    /**
     * 
     * @type {ValidationFrequency}
     * @memberof ValidationScheduleResponseDto
     */
    'frequency'?: ValidationFrequency;
    /**
     * 
     * @type {number}
     * @memberof ValidationScheduleResponseDto
     */
    'interval'?: number;
    /**
     * 
     * @type {number}
     * @memberof ValidationScheduleResponseDto
     */
    'startHour'?: number;
    /**
     * 
     * @type {number}
     * @memberof ValidationScheduleResponseDto
     */
    'startMinute'?: number;
    /**
     * 
     * @type {string}
     * @memberof ValidationScheduleResponseDto
     */
    'daysOfWeek'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ValidationScheduleResponseDto
     */
    'dayOfMonth'?: number;
    /**
     * 
     * @type {string}
     * @memberof ValidationScheduleResponseDto
     */
    'cronExpression'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ValidationScheduleResponseDto
     */
    'timeZoneName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ValidationScheduleResponseDto
     */
    'timeZoneOffset'?: string | null;
}
/**
 * 
 * @export
 * @interface ViewFieldInfoInput
 */
export interface ViewFieldInfoInput {
    /**
     * 
     * @type {string}
     * @memberof ViewFieldInfoInput
     */
    'viewSchema'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ViewFieldInfoInput
     */
    'viewName': string;
    /**
     * 
     * @type {string}
     * @memberof ViewFieldInfoInput
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ViewFieldInfoInput
     */
    'type'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ViewFieldInfoInput
     */
    'position': number;
    /**
     * 
     * @type {number}
     * @memberof ViewFieldInfoInput
     */
    'maxLength'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ViewFieldInfoInput
     */
    'precision'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ViewFieldInfoInput
     */
    'scale'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ViewFieldInfoInput
     */
    'sourceDatabaseName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ViewFieldInfoInput
     */
    'sourceSchemaName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ViewFieldInfoInput
     */
    'sourceTableName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ViewFieldInfoInput
     */
    'sourceColumnName'?: string | null;
}
/**
 * 
 * @export
 * @interface ViewInfoInput
 */
export interface ViewInfoInput {
    /**
     * 
     * @type {string}
     * @memberof ViewInfoInput
     */
    'schema'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ViewInfoInput
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ViewInfoInput
     */
    'viewDefinition': string;
}

/**
 * AdminApi - axios parameter creator
 * @export
 */
export const AdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [organizationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupAdminDatabasesSizeusageGet: async (organizationId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/backup/admin/databases/sizeusage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminApi - functional programming interface
 * @export
 */
export const AdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [organizationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBackupAdminDatabasesSizeusageGet(organizationId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBackupAdminDatabasesSizeusageGet(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminApi - factory interface
 * @export
 */
export const AdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [organizationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupAdminDatabasesSizeusageGet(organizationId?: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiBackupAdminDatabasesSizeusageGet(organizationId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminApi - object-oriented interface
 * @export
 * @class AdminApi
 * @extends {BaseAPI}
 */
export class AdminApi extends BaseAPI {
    /**
     * 
     * @param {number} [organizationId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public apiBackupAdminDatabasesSizeusageGet(organizationId?: number, options?: AxiosRequestConfig) {
        return AdminApiFp(this.configuration).apiBackupAdminDatabasesSizeusageGet(organizationId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * BackupApi - axios parameter creator
 * @export
 */
export const BackupApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateBackupInput} [createBackupInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupCreatePost: async (createBackupInput?: CreateBackupInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/backup/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createBackupInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupDashboardGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/backup/dashboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupDetailsGet: async (databaseId?: number, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/backup/details`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (databaseId !== undefined) {
                localVarQueryParameter['databaseId'] = databaseId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ValidateDownloadFileInput} [validateDownloadFileInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupDownladValidatefilePost: async (validateDownloadFileInput?: ValidateDownloadFileInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/backup/downlad/validatefile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(validateDownloadFileInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DownloadAuthenticateInput} [downloadAuthenticateInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupDownloadCompletePost: async (downloadAuthenticateInput?: DownloadAuthenticateInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/backup/download/complete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(downloadAuthenticateInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DownloadAuthenticateInput} [downloadAuthenticateInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupDownloadFailedPost: async (downloadAuthenticateInput?: DownloadAuthenticateInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/backup/download/failed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(downloadAuthenticateInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {number} [backupId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupDownloadGet: async (databaseId?: number, backupId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/backup/download`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (databaseId !== undefined) {
                localVarQueryParameter['databaseId'] = databaseId;
            }

            if (backupId !== undefined) {
                localVarQueryParameter['backupId'] = backupId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DownloadAuthenticateInput} [downloadAuthenticateInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupDownloadValidatePost: async (downloadAuthenticateInput?: DownloadAuthenticateInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/backup/download/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(downloadAuthenticateInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupEncryptableGet: async (databaseId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/backup/encryptable`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (databaseId !== undefined) {
                localVarQueryParameter['databaseId'] = databaseId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DatabaseType} [databaseType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupEnginesGet: async (databaseType?: DatabaseType, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/backup/engines`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (databaseType !== undefined) {
                localVarQueryParameter['databaseType'] = databaseType;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [organizationId] 
         * @param {CloudProvider} [provider] 
         * @param {string} [region] 
         * @param {GetBackupFilesWithUriInput} [getBackupFilesWithUriInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupFilesInternalPost: async (organizationId?: number, provider?: CloudProvider, region?: string, getBackupFilesWithUriInput?: GetBackupFilesWithUriInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/backup/files/internal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }

            if (provider !== undefined) {
                localVarQueryParameter['provider'] = provider;
            }

            if (region !== undefined) {
                localVarQueryParameter['region'] = region;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getBackupFilesWithUriInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetBackupFilesWithUriInput} [getBackupFilesWithUriInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupFilesPost: async (getBackupFilesWithUriInput?: GetBackupFilesWithUriInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/backup/files`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getBackupFilesWithUriInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [organizationId] 
         * @param {CreateBackupInput} [createBackupInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupInternalCreatePost: async (organizationId?: number, createBackupInput?: CreateBackupInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/backup/internal/create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createBackupInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [organizationId] 
         * @param {number} [databaseId] 
         * @param {number} [backupId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupInternalGet: async (organizationId?: number, databaseId?: number, backupId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/backup/internal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }

            if (databaseId !== undefined) {
                localVarQueryParameter['databaseId'] = databaseId;
            }

            if (backupId !== undefined) {
                localVarQueryParameter['backupId'] = backupId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {InternalListBackupsInput} [internalListBackupsInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupInternalListPost: async (internalListBackupsInput?: InternalListBackupsInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/backup/internal/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(internalListBackupsInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [organizationId] 
         * @param {number} [databaseId] 
         * @param {number} [backupId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupInternalMetricsfinishedGet: async (organizationId?: number, databaseId?: number, backupId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/backup/internal/metricsfinished`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }

            if (databaseId !== undefined) {
                localVarQueryParameter['databaseId'] = databaseId;
            }

            if (backupId !== undefined) {
                localVarQueryParameter['backupId'] = backupId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ClientReportDatabaseSizeInput} [clientReportDatabaseSizeInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupReportDbsizePost: async (clientReportDatabaseSizeInput?: ClientReportDatabaseSizeInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/backup/report/dbsize`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clientReportDatabaseSizeInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReportResultInput} [reportResultInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupReportRestorePost: async (reportResultInput?: ReportResultInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/backup/report/restore`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportResultInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DatabaseSchemaInput} [databaseSchemaInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupReportSchemaPost: async (databaseSchemaInput?: DatabaseSchemaInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/backup/report/schema`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(databaseSchemaInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReportResultInput} [reportResultInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupReportUploadPost: async (reportResultInput?: ReportResultInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/backup/report/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportResultInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReportResultInput} [reportResultInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupReportValidationPost: async (reportResultInput?: ReportResultInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/backup/report/validation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportResultInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupRetentiondaysGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/backup/retentiondays`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {NoSqlDatabaseSchemaInput} [noSqlDatabaseSchemaInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupSchemaonlyNosqlPost: async (noSqlDatabaseSchemaInput?: NoSqlDatabaseSchemaInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/backup/schemaonly/nosql`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(noSqlDatabaseSchemaInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SchemaOnlyBackupInput} [schemaOnlyBackupInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupSchemaonlyPost: async (schemaOnlyBackupInput?: SchemaOnlyBackupInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/backup/schemaonly`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(schemaOnlyBackupInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupSchemaonlyZipPost: async (databaseId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/backup/schemaonly/zip`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (databaseId !== undefined) {
                localVarQueryParameter['databaseId'] = databaseId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupUploadconfigGet: async (databaseId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/backup/uploadconfig`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (databaseId !== undefined) {
                localVarQueryParameter['databaseId'] = databaseId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {number} [backupId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupUploadjsonuriGet: async (databaseId?: number, backupId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/backup/uploadjsonuri`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (databaseId !== undefined) {
                localVarQueryParameter['databaseId'] = databaseId;
            }

            if (backupId !== undefined) {
                localVarQueryParameter['backupId'] = backupId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {number} [backupId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupUploaduriGet: async (databaseId?: number, backupId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/backup/uploaduri`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (databaseId !== undefined) {
                localVarQueryParameter['databaseId'] = databaseId;
            }

            if (backupId !== undefined) {
                localVarQueryParameter['backupId'] = backupId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BackupApi - functional programming interface
 * @export
 */
export const BackupApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BackupApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateBackupInput} [createBackupInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBackupCreatePost(createBackupInput?: CreateBackupInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBackupCreatePost(createBackupInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBackupDashboardGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BackupDashboardResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBackupDashboardGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBackupDetailsGet(databaseId?: number, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BackupResponseDtoPaginationResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBackupDetailsGet(databaseId, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ValidateDownloadFileInput} [validateDownloadFileInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBackupDownladValidatefilePost(validateDownloadFileInput?: ValidateDownloadFileInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBackupDownladValidatefilePost(validateDownloadFileInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DownloadAuthenticateInput} [downloadAuthenticateInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBackupDownloadCompletePost(downloadAuthenticateInput?: DownloadAuthenticateInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBackupDownloadCompletePost(downloadAuthenticateInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DownloadAuthenticateInput} [downloadAuthenticateInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBackupDownloadFailedPost(downloadAuthenticateInput?: DownloadAuthenticateInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBackupDownloadFailedPost(downloadAuthenticateInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {number} [backupId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBackupDownloadGet(databaseId?: number, backupId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBackupDownloadGet(databaseId, backupId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DownloadAuthenticateInput} [downloadAuthenticateInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBackupDownloadValidatePost(downloadAuthenticateInput?: DownloadAuthenticateInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBackupDownloadValidatePost(downloadAuthenticateInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBackupEncryptableGet(databaseId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BackupResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBackupEncryptableGet(databaseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DatabaseType} [databaseType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBackupEnginesGet(databaseType?: DatabaseType, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EngineResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBackupEnginesGet(databaseType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [organizationId] 
         * @param {CloudProvider} [provider] 
         * @param {string} [region] 
         * @param {GetBackupFilesWithUriInput} [getBackupFilesWithUriInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBackupFilesInternalPost(organizationId?: number, provider?: CloudProvider, region?: string, getBackupFilesWithUriInput?: GetBackupFilesWithUriInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBackupFilesInternalPost(organizationId, provider, region, getBackupFilesWithUriInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {GetBackupFilesWithUriInput} [getBackupFilesWithUriInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBackupFilesPost(getBackupFilesWithUriInput?: GetBackupFilesWithUriInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBackupFilesPost(getBackupFilesWithUriInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [organizationId] 
         * @param {CreateBackupInput} [createBackupInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBackupInternalCreatePost(organizationId?: number, createBackupInput?: CreateBackupInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBackupInternalCreatePost(organizationId, createBackupInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [organizationId] 
         * @param {number} [databaseId] 
         * @param {number} [backupId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBackupInternalGet(organizationId?: number, databaseId?: number, backupId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBackupInternalGet(organizationId, databaseId, backupId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {InternalListBackupsInput} [internalListBackupsInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBackupInternalListPost(internalListBackupsInput?: InternalListBackupsInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBackupInternalListPost(internalListBackupsInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [organizationId] 
         * @param {number} [databaseId] 
         * @param {number} [backupId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBackupInternalMetricsfinishedGet(organizationId?: number, databaseId?: number, backupId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBackupInternalMetricsfinishedGet(organizationId, databaseId, backupId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ClientReportDatabaseSizeInput} [clientReportDatabaseSizeInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBackupReportDbsizePost(clientReportDatabaseSizeInput?: ClientReportDatabaseSizeInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBackupReportDbsizePost(clientReportDatabaseSizeInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ReportResultInput} [reportResultInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBackupReportRestorePost(reportResultInput?: ReportResultInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBackupReportRestorePost(reportResultInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {DatabaseSchemaInput} [databaseSchemaInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBackupReportSchemaPost(databaseSchemaInput?: DatabaseSchemaInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBackupReportSchemaPost(databaseSchemaInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ReportResultInput} [reportResultInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBackupReportUploadPost(reportResultInput?: ReportResultInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBackupReportUploadPost(reportResultInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ReportResultInput} [reportResultInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBackupReportValidationPost(reportResultInput?: ReportResultInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBackupReportValidationPost(reportResultInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBackupRetentiondaysGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EnumOptionResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBackupRetentiondaysGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {NoSqlDatabaseSchemaInput} [noSqlDatabaseSchemaInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBackupSchemaonlyNosqlPost(noSqlDatabaseSchemaInput?: NoSqlDatabaseSchemaInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBackupSchemaonlyNosqlPost(noSqlDatabaseSchemaInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SchemaOnlyBackupInput} [schemaOnlyBackupInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBackupSchemaonlyPost(schemaOnlyBackupInput?: SchemaOnlyBackupInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBackupSchemaonlyPost(schemaOnlyBackupInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBackupSchemaonlyZipPost(databaseId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBackupSchemaonlyZipPost(databaseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBackupUploadconfigGet(databaseId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBackupUploadconfigGet(databaseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {number} [backupId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBackupUploadjsonuriGet(databaseId?: number, backupId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBackupUploadjsonuriGet(databaseId, backupId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {number} [backupId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBackupUploaduriGet(databaseId?: number, backupId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBackupUploaduriGet(databaseId, backupId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BackupApi - factory interface
 * @export
 */
export const BackupApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BackupApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateBackupInput} [createBackupInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupCreatePost(createBackupInput?: CreateBackupInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiBackupCreatePost(createBackupInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupDashboardGet(options?: any): AxiosPromise<BackupDashboardResponseDto> {
            return localVarFp.apiBackupDashboardGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupDetailsGet(databaseId?: number, page?: number, limit?: number, options?: any): AxiosPromise<BackupResponseDtoPaginationResult> {
            return localVarFp.apiBackupDetailsGet(databaseId, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ValidateDownloadFileInput} [validateDownloadFileInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupDownladValidatefilePost(validateDownloadFileInput?: ValidateDownloadFileInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiBackupDownladValidatefilePost(validateDownloadFileInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DownloadAuthenticateInput} [downloadAuthenticateInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupDownloadCompletePost(downloadAuthenticateInput?: DownloadAuthenticateInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiBackupDownloadCompletePost(downloadAuthenticateInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DownloadAuthenticateInput} [downloadAuthenticateInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupDownloadFailedPost(downloadAuthenticateInput?: DownloadAuthenticateInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiBackupDownloadFailedPost(downloadAuthenticateInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {number} [backupId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupDownloadGet(databaseId?: number, backupId?: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiBackupDownloadGet(databaseId, backupId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DownloadAuthenticateInput} [downloadAuthenticateInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupDownloadValidatePost(downloadAuthenticateInput?: DownloadAuthenticateInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiBackupDownloadValidatePost(downloadAuthenticateInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupEncryptableGet(databaseId?: number, options?: any): AxiosPromise<Array<BackupResponseDto>> {
            return localVarFp.apiBackupEncryptableGet(databaseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DatabaseType} [databaseType] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupEnginesGet(databaseType?: DatabaseType, options?: any): AxiosPromise<Array<EngineResponseDto>> {
            return localVarFp.apiBackupEnginesGet(databaseType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [organizationId] 
         * @param {CloudProvider} [provider] 
         * @param {string} [region] 
         * @param {GetBackupFilesWithUriInput} [getBackupFilesWithUriInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupFilesInternalPost(organizationId?: number, provider?: CloudProvider, region?: string, getBackupFilesWithUriInput?: GetBackupFilesWithUriInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiBackupFilesInternalPost(organizationId, provider, region, getBackupFilesWithUriInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetBackupFilesWithUriInput} [getBackupFilesWithUriInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupFilesPost(getBackupFilesWithUriInput?: GetBackupFilesWithUriInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiBackupFilesPost(getBackupFilesWithUriInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [organizationId] 
         * @param {CreateBackupInput} [createBackupInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupInternalCreatePost(organizationId?: number, createBackupInput?: CreateBackupInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiBackupInternalCreatePost(organizationId, createBackupInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [organizationId] 
         * @param {number} [databaseId] 
         * @param {number} [backupId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupInternalGet(organizationId?: number, databaseId?: number, backupId?: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiBackupInternalGet(organizationId, databaseId, backupId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {InternalListBackupsInput} [internalListBackupsInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupInternalListPost(internalListBackupsInput?: InternalListBackupsInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiBackupInternalListPost(internalListBackupsInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [organizationId] 
         * @param {number} [databaseId] 
         * @param {number} [backupId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupInternalMetricsfinishedGet(organizationId?: number, databaseId?: number, backupId?: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiBackupInternalMetricsfinishedGet(organizationId, databaseId, backupId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientReportDatabaseSizeInput} [clientReportDatabaseSizeInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupReportDbsizePost(clientReportDatabaseSizeInput?: ClientReportDatabaseSizeInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiBackupReportDbsizePost(clientReportDatabaseSizeInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportResultInput} [reportResultInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupReportRestorePost(reportResultInput?: ReportResultInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiBackupReportRestorePost(reportResultInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DatabaseSchemaInput} [databaseSchemaInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupReportSchemaPost(databaseSchemaInput?: DatabaseSchemaInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiBackupReportSchemaPost(databaseSchemaInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportResultInput} [reportResultInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupReportUploadPost(reportResultInput?: ReportResultInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiBackupReportUploadPost(reportResultInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportResultInput} [reportResultInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupReportValidationPost(reportResultInput?: ReportResultInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiBackupReportValidationPost(reportResultInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupRetentiondaysGet(options?: any): AxiosPromise<Array<EnumOptionResponseDto>> {
            return localVarFp.apiBackupRetentiondaysGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NoSqlDatabaseSchemaInput} [noSqlDatabaseSchemaInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupSchemaonlyNosqlPost(noSqlDatabaseSchemaInput?: NoSqlDatabaseSchemaInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiBackupSchemaonlyNosqlPost(noSqlDatabaseSchemaInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SchemaOnlyBackupInput} [schemaOnlyBackupInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupSchemaonlyPost(schemaOnlyBackupInput?: SchemaOnlyBackupInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiBackupSchemaonlyPost(schemaOnlyBackupInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupSchemaonlyZipPost(databaseId?: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiBackupSchemaonlyZipPost(databaseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupUploadconfigGet(databaseId?: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiBackupUploadconfigGet(databaseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {number} [backupId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupUploadjsonuriGet(databaseId?: number, backupId?: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiBackupUploadjsonuriGet(databaseId, backupId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {number} [backupId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBackupUploaduriGet(databaseId?: number, backupId?: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiBackupUploaduriGet(databaseId, backupId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BackupApi - object-oriented interface
 * @export
 * @class BackupApi
 * @extends {BaseAPI}
 */
export class BackupApi extends BaseAPI {
    /**
     * 
     * @param {CreateBackupInput} [createBackupInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackupApi
     */
    public apiBackupCreatePost(createBackupInput?: CreateBackupInput, options?: AxiosRequestConfig) {
        return BackupApiFp(this.configuration).apiBackupCreatePost(createBackupInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackupApi
     */
    public apiBackupDashboardGet(options?: AxiosRequestConfig) {
        return BackupApiFp(this.configuration).apiBackupDashboardGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [databaseId] 
     * @param {number} [page] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackupApi
     */
    public apiBackupDetailsGet(databaseId?: number, page?: number, limit?: number, options?: AxiosRequestConfig) {
        return BackupApiFp(this.configuration).apiBackupDetailsGet(databaseId, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ValidateDownloadFileInput} [validateDownloadFileInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackupApi
     */
    public apiBackupDownladValidatefilePost(validateDownloadFileInput?: ValidateDownloadFileInput, options?: AxiosRequestConfig) {
        return BackupApiFp(this.configuration).apiBackupDownladValidatefilePost(validateDownloadFileInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DownloadAuthenticateInput} [downloadAuthenticateInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackupApi
     */
    public apiBackupDownloadCompletePost(downloadAuthenticateInput?: DownloadAuthenticateInput, options?: AxiosRequestConfig) {
        return BackupApiFp(this.configuration).apiBackupDownloadCompletePost(downloadAuthenticateInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DownloadAuthenticateInput} [downloadAuthenticateInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackupApi
     */
    public apiBackupDownloadFailedPost(downloadAuthenticateInput?: DownloadAuthenticateInput, options?: AxiosRequestConfig) {
        return BackupApiFp(this.configuration).apiBackupDownloadFailedPost(downloadAuthenticateInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [databaseId] 
     * @param {number} [backupId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackupApi
     */
    public apiBackupDownloadGet(databaseId?: number, backupId?: number, options?: AxiosRequestConfig) {
        return BackupApiFp(this.configuration).apiBackupDownloadGet(databaseId, backupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DownloadAuthenticateInput} [downloadAuthenticateInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackupApi
     */
    public apiBackupDownloadValidatePost(downloadAuthenticateInput?: DownloadAuthenticateInput, options?: AxiosRequestConfig) {
        return BackupApiFp(this.configuration).apiBackupDownloadValidatePost(downloadAuthenticateInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [databaseId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackupApi
     */
    public apiBackupEncryptableGet(databaseId?: number, options?: AxiosRequestConfig) {
        return BackupApiFp(this.configuration).apiBackupEncryptableGet(databaseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DatabaseType} [databaseType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackupApi
     */
    public apiBackupEnginesGet(databaseType?: DatabaseType, options?: AxiosRequestConfig) {
        return BackupApiFp(this.configuration).apiBackupEnginesGet(databaseType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [organizationId] 
     * @param {CloudProvider} [provider] 
     * @param {string} [region] 
     * @param {GetBackupFilesWithUriInput} [getBackupFilesWithUriInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackupApi
     */
    public apiBackupFilesInternalPost(organizationId?: number, provider?: CloudProvider, region?: string, getBackupFilesWithUriInput?: GetBackupFilesWithUriInput, options?: AxiosRequestConfig) {
        return BackupApiFp(this.configuration).apiBackupFilesInternalPost(organizationId, provider, region, getBackupFilesWithUriInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetBackupFilesWithUriInput} [getBackupFilesWithUriInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackupApi
     */
    public apiBackupFilesPost(getBackupFilesWithUriInput?: GetBackupFilesWithUriInput, options?: AxiosRequestConfig) {
        return BackupApiFp(this.configuration).apiBackupFilesPost(getBackupFilesWithUriInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [organizationId] 
     * @param {CreateBackupInput} [createBackupInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackupApi
     */
    public apiBackupInternalCreatePost(organizationId?: number, createBackupInput?: CreateBackupInput, options?: AxiosRequestConfig) {
        return BackupApiFp(this.configuration).apiBackupInternalCreatePost(organizationId, createBackupInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [organizationId] 
     * @param {number} [databaseId] 
     * @param {number} [backupId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackupApi
     */
    public apiBackupInternalGet(organizationId?: number, databaseId?: number, backupId?: number, options?: AxiosRequestConfig) {
        return BackupApiFp(this.configuration).apiBackupInternalGet(organizationId, databaseId, backupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {InternalListBackupsInput} [internalListBackupsInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackupApi
     */
    public apiBackupInternalListPost(internalListBackupsInput?: InternalListBackupsInput, options?: AxiosRequestConfig) {
        return BackupApiFp(this.configuration).apiBackupInternalListPost(internalListBackupsInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [organizationId] 
     * @param {number} [databaseId] 
     * @param {number} [backupId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackupApi
     */
    public apiBackupInternalMetricsfinishedGet(organizationId?: number, databaseId?: number, backupId?: number, options?: AxiosRequestConfig) {
        return BackupApiFp(this.configuration).apiBackupInternalMetricsfinishedGet(organizationId, databaseId, backupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientReportDatabaseSizeInput} [clientReportDatabaseSizeInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackupApi
     */
    public apiBackupReportDbsizePost(clientReportDatabaseSizeInput?: ClientReportDatabaseSizeInput, options?: AxiosRequestConfig) {
        return BackupApiFp(this.configuration).apiBackupReportDbsizePost(clientReportDatabaseSizeInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportResultInput} [reportResultInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackupApi
     */
    public apiBackupReportRestorePost(reportResultInput?: ReportResultInput, options?: AxiosRequestConfig) {
        return BackupApiFp(this.configuration).apiBackupReportRestorePost(reportResultInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DatabaseSchemaInput} [databaseSchemaInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackupApi
     */
    public apiBackupReportSchemaPost(databaseSchemaInput?: DatabaseSchemaInput, options?: AxiosRequestConfig) {
        return BackupApiFp(this.configuration).apiBackupReportSchemaPost(databaseSchemaInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportResultInput} [reportResultInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackupApi
     */
    public apiBackupReportUploadPost(reportResultInput?: ReportResultInput, options?: AxiosRequestConfig) {
        return BackupApiFp(this.configuration).apiBackupReportUploadPost(reportResultInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportResultInput} [reportResultInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackupApi
     */
    public apiBackupReportValidationPost(reportResultInput?: ReportResultInput, options?: AxiosRequestConfig) {
        return BackupApiFp(this.configuration).apiBackupReportValidationPost(reportResultInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackupApi
     */
    public apiBackupRetentiondaysGet(options?: AxiosRequestConfig) {
        return BackupApiFp(this.configuration).apiBackupRetentiondaysGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NoSqlDatabaseSchemaInput} [noSqlDatabaseSchemaInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackupApi
     */
    public apiBackupSchemaonlyNosqlPost(noSqlDatabaseSchemaInput?: NoSqlDatabaseSchemaInput, options?: AxiosRequestConfig) {
        return BackupApiFp(this.configuration).apiBackupSchemaonlyNosqlPost(noSqlDatabaseSchemaInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SchemaOnlyBackupInput} [schemaOnlyBackupInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackupApi
     */
    public apiBackupSchemaonlyPost(schemaOnlyBackupInput?: SchemaOnlyBackupInput, options?: AxiosRequestConfig) {
        return BackupApiFp(this.configuration).apiBackupSchemaonlyPost(schemaOnlyBackupInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [databaseId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackupApi
     */
    public apiBackupSchemaonlyZipPost(databaseId?: number, options?: AxiosRequestConfig) {
        return BackupApiFp(this.configuration).apiBackupSchemaonlyZipPost(databaseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [databaseId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackupApi
     */
    public apiBackupUploadconfigGet(databaseId?: number, options?: AxiosRequestConfig) {
        return BackupApiFp(this.configuration).apiBackupUploadconfigGet(databaseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [databaseId] 
     * @param {number} [backupId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackupApi
     */
    public apiBackupUploadjsonuriGet(databaseId?: number, backupId?: number, options?: AxiosRequestConfig) {
        return BackupApiFp(this.configuration).apiBackupUploadjsonuriGet(databaseId, backupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [databaseId] 
     * @param {number} [backupId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackupApi
     */
    public apiBackupUploaduriGet(databaseId?: number, backupId?: number, options?: AxiosRequestConfig) {
        return BackupApiFp(this.configuration).apiBackupUploaduriGet(databaseId, backupId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DatabasesApi - axios parameter creator
 * @export
 */
export const DatabasesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} databaseId 
         * @param {ClientUpdateDatabaseInput} [clientUpdateDatabaseInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesClientDatabaseIdPut: async (databaseId: number, clientUpdateDatabaseInput?: ClientUpdateDatabaseInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'databaseId' is not null or undefined
            assertParamExists('apiDatabasesClientDatabaseIdPut', 'databaseId', databaseId)
            const localVarPath = `/api/databases/client/{databaseId}`
                .replace(`{${"databaseId"}}`, encodeURIComponent(String(databaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clientUpdateDatabaseInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} encodedName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesClientEncodedNameGet: async (encodedName: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'encodedName' is not null or undefined
            assertParamExists('apiDatabasesClientEncodedNameGet', 'encodedName', encodedName)
            const localVarPath = `/api/databases/client/{encodedName}`
                .replace(`{${"encodedName"}}`, encodeURIComponent(String(encodedName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} encodedName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesClientListEncodedNameGet: async (encodedName: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'encodedName' is not null or undefined
            assertParamExists('apiDatabasesClientListEncodedNameGet', 'encodedName', encodedName)
            const localVarPath = `/api/databases/client/list/{encodedName}`
                .replace(`{${"encodedName"}}`, encodeURIComponent(String(encodedName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ClientCreateDatabaseInput} [clientCreateDatabaseInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesClientPost: async (clientCreateDatabaseInput?: ClientCreateDatabaseInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/databases/client`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clientCreateDatabaseInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {BackupType} backupType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesDatabaseIdBackupscheduleBackupTypeDelete: async (databaseId: number, backupType: BackupType, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'databaseId' is not null or undefined
            assertParamExists('apiDatabasesDatabaseIdBackupscheduleBackupTypeDelete', 'databaseId', databaseId)
            // verify required parameter 'backupType' is not null or undefined
            assertParamExists('apiDatabasesDatabaseIdBackupscheduleBackupTypeDelete', 'backupType', backupType)
            const localVarPath = `/api/databases/{databaseId}/backupschedule/{backupType}`
                .replace(`{${"databaseId"}}`, encodeURIComponent(String(databaseId)))
                .replace(`{${"backupType"}}`, encodeURIComponent(String(backupType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {BackupType} backupType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesDatabaseIdBackupscheduleBackupTypeGet: async (databaseId: number, backupType: BackupType, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'databaseId' is not null or undefined
            assertParamExists('apiDatabasesDatabaseIdBackupscheduleBackupTypeGet', 'databaseId', databaseId)
            // verify required parameter 'backupType' is not null or undefined
            assertParamExists('apiDatabasesDatabaseIdBackupscheduleBackupTypeGet', 'backupType', backupType)
            const localVarPath = `/api/databases/{databaseId}/backupschedule/{backupType}`
                .replace(`{${"databaseId"}}`, encodeURIComponent(String(databaseId)))
                .replace(`{${"backupType"}}`, encodeURIComponent(String(backupType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesDatabaseIdBackupscheduleGet: async (databaseId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'databaseId' is not null or undefined
            assertParamExists('apiDatabasesDatabaseIdBackupscheduleGet', 'databaseId', databaseId)
            const localVarPath = `/api/databases/{databaseId}/backupschedule`
                .replace(`{${"databaseId"}}`, encodeURIComponent(String(databaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {BackupScheduleInput} [backupScheduleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesDatabaseIdBackupschedulePost: async (databaseId: number, backupScheduleInput?: BackupScheduleInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'databaseId' is not null or undefined
            assertParamExists('apiDatabasesDatabaseIdBackupschedulePost', 'databaseId', databaseId)
            const localVarPath = `/api/databases/{databaseId}/backupschedule`
                .replace(`{${"databaseId"}}`, encodeURIComponent(String(databaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(backupScheduleInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {BackupScheduleInput} [backupScheduleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesDatabaseIdBackupschedulePut: async (databaseId: number, backupScheduleInput?: BackupScheduleInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'databaseId' is not null or undefined
            assertParamExists('apiDatabasesDatabaseIdBackupschedulePut', 'databaseId', databaseId)
            const localVarPath = `/api/databases/{databaseId}/backupschedule`
                .replace(`{${"databaseId"}}`, encodeURIComponent(String(databaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(backupScheduleInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesDatabaseIdBackuptypesGet: async (databaseId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'databaseId' is not null or undefined
            assertParamExists('apiDatabasesDatabaseIdBackuptypesGet', 'databaseId', databaseId)
            const localVarPath = `/api/databases/{databaseId}/backuptypes`
                .replace(`{${"databaseId"}}`, encodeURIComponent(String(databaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {CloneDatabaseInput} [cloneDatabaseInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesDatabaseIdClonePost: async (databaseId: number, cloneDatabaseInput?: CloneDatabaseInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'databaseId' is not null or undefined
            assertParamExists('apiDatabasesDatabaseIdClonePost', 'databaseId', databaseId)
            const localVarPath = `/api/databases/{databaseId}/clone`
                .replace(`{${"databaseId"}}`, encodeURIComponent(String(databaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cloneDatabaseInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesDatabaseIdDelete: async (databaseId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'databaseId' is not null or undefined
            assertParamExists('apiDatabasesDatabaseIdDelete', 'databaseId', databaseId)
            const localVarPath = `/api/databases/{databaseId}`
                .replace(`{${"databaseId"}}`, encodeURIComponent(String(databaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {UpdateDatabaseInput} [updateDatabaseInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesDatabaseIdPut: async (databaseId: number, updateDatabaseInput?: UpdateDatabaseInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'databaseId' is not null or undefined
            assertParamExists('apiDatabasesDatabaseIdPut', 'databaseId', databaseId)
            const localVarPath = `/api/databases/{databaseId}`
                .replace(`{${"databaseId"}}`, encodeURIComponent(String(databaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDatabaseInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesDatabaseIdValidationscheduleGet: async (databaseId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'databaseId' is not null or undefined
            assertParamExists('apiDatabasesDatabaseIdValidationscheduleGet', 'databaseId', databaseId)
            const localVarPath = `/api/databases/{databaseId}/validationschedule`
                .replace(`{${"databaseId"}}`, encodeURIComponent(String(databaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {ValidationScheduleInput} [validationScheduleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesDatabaseIdValidationschedulePut: async (databaseId: number, validationScheduleInput?: ValidationScheduleInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'databaseId' is not null or undefined
            assertParamExists('apiDatabasesDatabaseIdValidationschedulePut', 'databaseId', databaseId)
            const localVarPath = `/api/databases/{databaseId}/validationschedule`
                .replace(`{${"databaseId"}}`, encodeURIComponent(String(databaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(validationScheduleInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/databases`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [organizationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesInternalGet: async (organizationId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/databases/internal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [organizationId] 
         * @param {number} [fromDatabaseId] 
         * @param {number} [userId] 
         * @param {CreateDatabaseInput} [createDatabaseInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesInternalPost: async (organizationId?: number, fromDatabaseId?: number, userId?: number, createDatabaseInput?: CreateDatabaseInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/databases/internal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }

            if (fromDatabaseId !== undefined) {
                localVarQueryParameter['fromDatabaseId'] = fromDatabaseId;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDatabaseInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesIsnotificationenabledGet: async (databaseId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/databases/isnotificationenabled`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (databaseId !== undefined) {
                localVarQueryParameter['databaseId'] = databaseId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateDatabaseInput} [createDatabaseInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesPost: async (createDatabaseInput?: CreateDatabaseInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/databases`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createDatabaseInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesSwitchnotiDatabaseIdPut: async (databaseId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'databaseId' is not null or undefined
            assertParamExists('apiDatabasesSwitchnotiDatabaseIdPut', 'databaseId', databaseId)
            const localVarPath = `/api/databases/switchnoti/{databaseId}`
                .replace(`{${"databaseId"}}`, encodeURIComponent(String(databaseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesTypesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/databases/types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DatabasesApi - functional programming interface
 * @export
 */
export const DatabasesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DatabasesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} databaseId 
         * @param {ClientUpdateDatabaseInput} [clientUpdateDatabaseInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDatabasesClientDatabaseIdPut(databaseId: number, clientUpdateDatabaseInput?: ClientUpdateDatabaseInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDatabasesClientDatabaseIdPut(databaseId, clientUpdateDatabaseInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} encodedName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDatabasesClientEncodedNameGet(encodedName: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDatabasesClientEncodedNameGet(encodedName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} encodedName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDatabasesClientListEncodedNameGet(encodedName: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDatabasesClientListEncodedNameGet(encodedName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ClientCreateDatabaseInput} [clientCreateDatabaseInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDatabasesClientPost(clientCreateDatabaseInput?: ClientCreateDatabaseInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDatabasesClientPost(clientCreateDatabaseInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {BackupType} backupType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDatabasesDatabaseIdBackupscheduleBackupTypeDelete(databaseId: number, backupType: BackupType, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDatabasesDatabaseIdBackupscheduleBackupTypeDelete(databaseId, backupType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {BackupType} backupType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDatabasesDatabaseIdBackupscheduleBackupTypeGet(databaseId: number, backupType: BackupType, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BackupScheduleResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDatabasesDatabaseIdBackupscheduleBackupTypeGet(databaseId, backupType, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDatabasesDatabaseIdBackupscheduleGet(databaseId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BackupScheduleResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDatabasesDatabaseIdBackupscheduleGet(databaseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {BackupScheduleInput} [backupScheduleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDatabasesDatabaseIdBackupschedulePost(databaseId: number, backupScheduleInput?: BackupScheduleInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDatabasesDatabaseIdBackupschedulePost(databaseId, backupScheduleInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {BackupScheduleInput} [backupScheduleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDatabasesDatabaseIdBackupschedulePut(databaseId: number, backupScheduleInput?: BackupScheduleInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDatabasesDatabaseIdBackupschedulePut(databaseId, backupScheduleInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDatabasesDatabaseIdBackuptypesGet(databaseId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BackupTypeResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDatabasesDatabaseIdBackuptypesGet(databaseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {CloneDatabaseInput} [cloneDatabaseInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDatabasesDatabaseIdClonePost(databaseId: number, cloneDatabaseInput?: CloneDatabaseInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDatabasesDatabaseIdClonePost(databaseId, cloneDatabaseInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDatabasesDatabaseIdDelete(databaseId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDatabasesDatabaseIdDelete(databaseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {UpdateDatabaseInput} [updateDatabaseInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDatabasesDatabaseIdPut(databaseId: number, updateDatabaseInput?: UpdateDatabaseInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDatabasesDatabaseIdPut(databaseId, updateDatabaseInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDatabasesDatabaseIdValidationscheduleGet(databaseId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ValidationScheduleResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDatabasesDatabaseIdValidationscheduleGet(databaseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {ValidationScheduleInput} [validationScheduleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDatabasesDatabaseIdValidationschedulePut(databaseId: number, validationScheduleInput?: ValidationScheduleInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDatabasesDatabaseIdValidationschedulePut(databaseId, validationScheduleInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDatabasesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DatabaseResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDatabasesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [organizationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDatabasesInternalGet(organizationId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDatabasesInternalGet(organizationId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [organizationId] 
         * @param {number} [fromDatabaseId] 
         * @param {number} [userId] 
         * @param {CreateDatabaseInput} [createDatabaseInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDatabasesInternalPost(organizationId?: number, fromDatabaseId?: number, userId?: number, createDatabaseInput?: CreateDatabaseInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDatabasesInternalPost(organizationId, fromDatabaseId, userId, createDatabaseInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDatabasesIsnotificationenabledGet(databaseId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDatabasesIsnotificationenabledGet(databaseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateDatabaseInput} [createDatabaseInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDatabasesPost(createDatabaseInput?: CreateDatabaseInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDatabasesPost(createDatabaseInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDatabasesSwitchnotiDatabaseIdPut(databaseId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDatabasesSwitchnotiDatabaseIdPut(databaseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDatabasesTypesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EnumOptionResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDatabasesTypesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DatabasesApi - factory interface
 * @export
 */
export const DatabasesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DatabasesApiFp(configuration)
    return {
        /**
         * 
         * @param {number} databaseId 
         * @param {ClientUpdateDatabaseInput} [clientUpdateDatabaseInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesClientDatabaseIdPut(databaseId: number, clientUpdateDatabaseInput?: ClientUpdateDatabaseInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiDatabasesClientDatabaseIdPut(databaseId, clientUpdateDatabaseInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} encodedName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesClientEncodedNameGet(encodedName: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiDatabasesClientEncodedNameGet(encodedName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} encodedName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesClientListEncodedNameGet(encodedName: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiDatabasesClientListEncodedNameGet(encodedName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ClientCreateDatabaseInput} [clientCreateDatabaseInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesClientPost(clientCreateDatabaseInput?: ClientCreateDatabaseInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiDatabasesClientPost(clientCreateDatabaseInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {BackupType} backupType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesDatabaseIdBackupscheduleBackupTypeDelete(databaseId: number, backupType: BackupType, options?: any): AxiosPromise<void> {
            return localVarFp.apiDatabasesDatabaseIdBackupscheduleBackupTypeDelete(databaseId, backupType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {BackupType} backupType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesDatabaseIdBackupscheduleBackupTypeGet(databaseId: number, backupType: BackupType, options?: any): AxiosPromise<BackupScheduleResponseDto> {
            return localVarFp.apiDatabasesDatabaseIdBackupscheduleBackupTypeGet(databaseId, backupType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesDatabaseIdBackupscheduleGet(databaseId: number, options?: any): AxiosPromise<Array<BackupScheduleResponseDto>> {
            return localVarFp.apiDatabasesDatabaseIdBackupscheduleGet(databaseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {BackupScheduleInput} [backupScheduleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesDatabaseIdBackupschedulePost(databaseId: number, backupScheduleInput?: BackupScheduleInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiDatabasesDatabaseIdBackupschedulePost(databaseId, backupScheduleInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {BackupScheduleInput} [backupScheduleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesDatabaseIdBackupschedulePut(databaseId: number, backupScheduleInput?: BackupScheduleInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiDatabasesDatabaseIdBackupschedulePut(databaseId, backupScheduleInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesDatabaseIdBackuptypesGet(databaseId: number, options?: any): AxiosPromise<Array<BackupTypeResponseDto>> {
            return localVarFp.apiDatabasesDatabaseIdBackuptypesGet(databaseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {CloneDatabaseInput} [cloneDatabaseInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesDatabaseIdClonePost(databaseId: number, cloneDatabaseInput?: CloneDatabaseInput, options?: any): AxiosPromise<number> {
            return localVarFp.apiDatabasesDatabaseIdClonePost(databaseId, cloneDatabaseInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesDatabaseIdDelete(databaseId: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiDatabasesDatabaseIdDelete(databaseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {UpdateDatabaseInput} [updateDatabaseInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesDatabaseIdPut(databaseId: number, updateDatabaseInput?: UpdateDatabaseInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiDatabasesDatabaseIdPut(databaseId, updateDatabaseInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesDatabaseIdValidationscheduleGet(databaseId: number, options?: any): AxiosPromise<ValidationScheduleResponseDto> {
            return localVarFp.apiDatabasesDatabaseIdValidationscheduleGet(databaseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {ValidationScheduleInput} [validationScheduleInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesDatabaseIdValidationschedulePut(databaseId: number, validationScheduleInput?: ValidationScheduleInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiDatabasesDatabaseIdValidationschedulePut(databaseId, validationScheduleInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesGet(options?: any): AxiosPromise<Array<DatabaseResponseDto>> {
            return localVarFp.apiDatabasesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [organizationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesInternalGet(organizationId?: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiDatabasesInternalGet(organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [organizationId] 
         * @param {number} [fromDatabaseId] 
         * @param {number} [userId] 
         * @param {CreateDatabaseInput} [createDatabaseInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesInternalPost(organizationId?: number, fromDatabaseId?: number, userId?: number, createDatabaseInput?: CreateDatabaseInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiDatabasesInternalPost(organizationId, fromDatabaseId, userId, createDatabaseInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesIsnotificationenabledGet(databaseId?: number, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiDatabasesIsnotificationenabledGet(databaseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CreateDatabaseInput} [createDatabaseInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesPost(createDatabaseInput?: CreateDatabaseInput, options?: any): AxiosPromise<number> {
            return localVarFp.apiDatabasesPost(createDatabaseInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} databaseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesSwitchnotiDatabaseIdPut(databaseId: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiDatabasesSwitchnotiDatabaseIdPut(databaseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDatabasesTypesGet(options?: any): AxiosPromise<Array<EnumOptionResponseDto>> {
            return localVarFp.apiDatabasesTypesGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DatabasesApi - object-oriented interface
 * @export
 * @class DatabasesApi
 * @extends {BaseAPI}
 */
export class DatabasesApi extends BaseAPI {
    /**
     * 
     * @param {number} databaseId 
     * @param {ClientUpdateDatabaseInput} [clientUpdateDatabaseInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatabasesApi
     */
    public apiDatabasesClientDatabaseIdPut(databaseId: number, clientUpdateDatabaseInput?: ClientUpdateDatabaseInput, options?: AxiosRequestConfig) {
        return DatabasesApiFp(this.configuration).apiDatabasesClientDatabaseIdPut(databaseId, clientUpdateDatabaseInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} encodedName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatabasesApi
     */
    public apiDatabasesClientEncodedNameGet(encodedName: string, options?: AxiosRequestConfig) {
        return DatabasesApiFp(this.configuration).apiDatabasesClientEncodedNameGet(encodedName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} encodedName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatabasesApi
     */
    public apiDatabasesClientListEncodedNameGet(encodedName: string, options?: AxiosRequestConfig) {
        return DatabasesApiFp(this.configuration).apiDatabasesClientListEncodedNameGet(encodedName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ClientCreateDatabaseInput} [clientCreateDatabaseInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatabasesApi
     */
    public apiDatabasesClientPost(clientCreateDatabaseInput?: ClientCreateDatabaseInput, options?: AxiosRequestConfig) {
        return DatabasesApiFp(this.configuration).apiDatabasesClientPost(clientCreateDatabaseInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} databaseId 
     * @param {BackupType} backupType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatabasesApi
     */
    public apiDatabasesDatabaseIdBackupscheduleBackupTypeDelete(databaseId: number, backupType: BackupType, options?: AxiosRequestConfig) {
        return DatabasesApiFp(this.configuration).apiDatabasesDatabaseIdBackupscheduleBackupTypeDelete(databaseId, backupType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} databaseId 
     * @param {BackupType} backupType 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatabasesApi
     */
    public apiDatabasesDatabaseIdBackupscheduleBackupTypeGet(databaseId: number, backupType: BackupType, options?: AxiosRequestConfig) {
        return DatabasesApiFp(this.configuration).apiDatabasesDatabaseIdBackupscheduleBackupTypeGet(databaseId, backupType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} databaseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatabasesApi
     */
    public apiDatabasesDatabaseIdBackupscheduleGet(databaseId: number, options?: AxiosRequestConfig) {
        return DatabasesApiFp(this.configuration).apiDatabasesDatabaseIdBackupscheduleGet(databaseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} databaseId 
     * @param {BackupScheduleInput} [backupScheduleInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatabasesApi
     */
    public apiDatabasesDatabaseIdBackupschedulePost(databaseId: number, backupScheduleInput?: BackupScheduleInput, options?: AxiosRequestConfig) {
        return DatabasesApiFp(this.configuration).apiDatabasesDatabaseIdBackupschedulePost(databaseId, backupScheduleInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} databaseId 
     * @param {BackupScheduleInput} [backupScheduleInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatabasesApi
     */
    public apiDatabasesDatabaseIdBackupschedulePut(databaseId: number, backupScheduleInput?: BackupScheduleInput, options?: AxiosRequestConfig) {
        return DatabasesApiFp(this.configuration).apiDatabasesDatabaseIdBackupschedulePut(databaseId, backupScheduleInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} databaseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatabasesApi
     */
    public apiDatabasesDatabaseIdBackuptypesGet(databaseId: number, options?: AxiosRequestConfig) {
        return DatabasesApiFp(this.configuration).apiDatabasesDatabaseIdBackuptypesGet(databaseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} databaseId 
     * @param {CloneDatabaseInput} [cloneDatabaseInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatabasesApi
     */
    public apiDatabasesDatabaseIdClonePost(databaseId: number, cloneDatabaseInput?: CloneDatabaseInput, options?: AxiosRequestConfig) {
        return DatabasesApiFp(this.configuration).apiDatabasesDatabaseIdClonePost(databaseId, cloneDatabaseInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} databaseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatabasesApi
     */
    public apiDatabasesDatabaseIdDelete(databaseId: number, options?: AxiosRequestConfig) {
        return DatabasesApiFp(this.configuration).apiDatabasesDatabaseIdDelete(databaseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} databaseId 
     * @param {UpdateDatabaseInput} [updateDatabaseInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatabasesApi
     */
    public apiDatabasesDatabaseIdPut(databaseId: number, updateDatabaseInput?: UpdateDatabaseInput, options?: AxiosRequestConfig) {
        return DatabasesApiFp(this.configuration).apiDatabasesDatabaseIdPut(databaseId, updateDatabaseInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} databaseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatabasesApi
     */
    public apiDatabasesDatabaseIdValidationscheduleGet(databaseId: number, options?: AxiosRequestConfig) {
        return DatabasesApiFp(this.configuration).apiDatabasesDatabaseIdValidationscheduleGet(databaseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} databaseId 
     * @param {ValidationScheduleInput} [validationScheduleInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatabasesApi
     */
    public apiDatabasesDatabaseIdValidationschedulePut(databaseId: number, validationScheduleInput?: ValidationScheduleInput, options?: AxiosRequestConfig) {
        return DatabasesApiFp(this.configuration).apiDatabasesDatabaseIdValidationschedulePut(databaseId, validationScheduleInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatabasesApi
     */
    public apiDatabasesGet(options?: AxiosRequestConfig) {
        return DatabasesApiFp(this.configuration).apiDatabasesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [organizationId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatabasesApi
     */
    public apiDatabasesInternalGet(organizationId?: number, options?: AxiosRequestConfig) {
        return DatabasesApiFp(this.configuration).apiDatabasesInternalGet(organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [organizationId] 
     * @param {number} [fromDatabaseId] 
     * @param {number} [userId] 
     * @param {CreateDatabaseInput} [createDatabaseInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatabasesApi
     */
    public apiDatabasesInternalPost(organizationId?: number, fromDatabaseId?: number, userId?: number, createDatabaseInput?: CreateDatabaseInput, options?: AxiosRequestConfig) {
        return DatabasesApiFp(this.configuration).apiDatabasesInternalPost(organizationId, fromDatabaseId, userId, createDatabaseInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [databaseId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatabasesApi
     */
    public apiDatabasesIsnotificationenabledGet(databaseId?: number, options?: AxiosRequestConfig) {
        return DatabasesApiFp(this.configuration).apiDatabasesIsnotificationenabledGet(databaseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CreateDatabaseInput} [createDatabaseInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatabasesApi
     */
    public apiDatabasesPost(createDatabaseInput?: CreateDatabaseInput, options?: AxiosRequestConfig) {
        return DatabasesApiFp(this.configuration).apiDatabasesPost(createDatabaseInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} databaseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatabasesApi
     */
    public apiDatabasesSwitchnotiDatabaseIdPut(databaseId: number, options?: AxiosRequestConfig) {
        return DatabasesApiFp(this.configuration).apiDatabasesSwitchnotiDatabaseIdPut(databaseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DatabasesApi
     */
    public apiDatabasesTypesGet(options?: AxiosRequestConfig) {
        return DatabasesApiFp(this.configuration).apiDatabasesTypesGet(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * KeysApi - axios parameter creator
 * @export
 */
export const KeysApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {DecryptThenEncryptInput} [decryptThenEncryptInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiKeysInternalDecryptThenEncryptPost: async (decryptThenEncryptInput?: DecryptThenEncryptInput, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/keys/internalDecryptThenEncrypt`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(decryptThenEncryptInput, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiKeysPublicGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/keys/public`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * KeysApi - functional programming interface
 * @export
 */
export const KeysApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = KeysApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {DecryptThenEncryptInput} [decryptThenEncryptInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiKeysInternalDecryptThenEncryptPost(decryptThenEncryptInput?: DecryptThenEncryptInput, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiKeysInternalDecryptThenEncryptPost(decryptThenEncryptInput, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiKeysPublicGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiKeysPublicGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * KeysApi - factory interface
 * @export
 */
export const KeysApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = KeysApiFp(configuration)
    return {
        /**
         * 
         * @param {DecryptThenEncryptInput} [decryptThenEncryptInput] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiKeysInternalDecryptThenEncryptPost(decryptThenEncryptInput?: DecryptThenEncryptInput, options?: any): AxiosPromise<void> {
            return localVarFp.apiKeysInternalDecryptThenEncryptPost(decryptThenEncryptInput, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiKeysPublicGet(options?: any): AxiosPromise<void> {
            return localVarFp.apiKeysPublicGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * KeysApi - object-oriented interface
 * @export
 * @class KeysApi
 * @extends {BaseAPI}
 */
export class KeysApi extends BaseAPI {
    /**
     * 
     * @param {DecryptThenEncryptInput} [decryptThenEncryptInput] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KeysApi
     */
    public apiKeysInternalDecryptThenEncryptPost(decryptThenEncryptInput?: DecryptThenEncryptInput, options?: AxiosRequestConfig) {
        return KeysApiFp(this.configuration).apiKeysInternalDecryptThenEncryptPost(decryptThenEncryptInput, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KeysApi
     */
    public apiKeysPublicGet(options?: AxiosRequestConfig) {
        return KeysApiFp(this.configuration).apiKeysPublicGet(options).then((request) => request(this.axios, this.basePath));
    }
}


